import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useReportResult } from 'app/dataProviders/reports/hooks'
import { Loading } from 'app/common/templates-next/page-template'
import { ReportSection, Stub, ReportDetailsRoot } from 'app/common/templates-next/report-template'
import { ReportStatusIndicator } from 'app/components/common/reports/v3/ReportStatusIndicator'
import { ReportType } from 'app/dataTypes/reports'

import { HeaderBar } from './HeaderBar'
import { ReportTable } from './ReportTable'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import styles from './Report.module.scss'
import { Summary } from './Summary'
import { useCurrencySign } from 'app/common/components-next/currency'

type Props = {
  reportID: null | string
  onReportId?: (reportID: string | null) => void
}

export const Report = ({ reportID, onReportId }: Props) => {
  const { t } = useTranslation('cafeteria')
  const currency = useCurrencySign()

  const resetReport = useCallback(() => onReportId?.(null), [onReportId])

  const { requestResult, data, loading } = useReportResult(reportID, ReportType.SubsidiesAct)

  const hasMainTableColumns = !!data && (
    data.rows.dayCares.length > 0 || data.rows.klasses.length > 0
  )

  const reportEmpty = !reportID
  const reportPrepare = !(reportID && data)

  const header = reportEmpty ? '' : 'Отчет «Дотации»'

  return (
    <ReportSection
      header={header}
      headerBar={<HeaderBar reportID={reportID} reportReady={!reportPrepare && !reportEmpty} />}
      fullscreenEnabled={!reportPrepare && !reportEmpty && hasMainTableColumns}
      skipPadding
    >
      {reportID && (
        <ReportStatusIndicator reportID={reportID} onFail={resetReport} onSuccess={requestResult} />
      )}

      {reportPrepare && <Stub />}

      {loading && data && <Loading />}

      {!loading && !hasMainTableColumns && (
        <EmptyWarn className={styles.empty}>
          {t('orders_table_empty', 'Нет данных за выбранный период')}
        </EmptyWarn>
      )}
      {!reportPrepare && data && (
        <Summary
          summary={data.summary}
          currency={currency}
          pending={loading}
        />
      )}

      {data && hasMainTableColumns && (
        <ReportDetailsRoot header="Детализация отчета «Дотации»">
          <ReportTable
            data={data}
            pending={loading}
          />
        </ReportDetailsRoot>
      )}
    </ReportSection>
  )
}
